import './styles.css';
import React from 'react';
export const Aviso = () => {
  return (
    <div className="aviso-container">
      <h1>Atenção</h1>
      <p>
        Você acabou de participar de um simulado de phishing conduzido pela equipe de TI da{' '}
        <span className="highlight">Empresa SPSP</span>.
      </p>
      <div className="alert">
        <p>
          Felizmente, este foi apenas um teste, mas em um cenário real, você poderia ter caído em um golpe e colocado
          informações importantes em risco, comprometendo toda a organização.
        </p>
      </div>
      <p>
        Gostaríamos de reforçar que:{' '}
        <span className="highlight">A Empresa SPSP jamais solicita alterações de dados sensíveis por e-mail.</span> É
        essencial verificar o remetente e o site de destino antes de clicar em links ou fornecer qualquer informação.
      </p>
      <p>
        Esse teste foi realizado em um ambiente controlado pela nossa equipe de Tecnologia da Informação, com o objetivo
        de aprimorar sua conscientização sobre cibersegurança.
      </p>
      <p>
        Fique atento e, em caso de dúvidas, entre em contato com o suporte de TI. Sua atenção é fundamental para
        proteger os dados da empresa.
      </p>
    </div>
  );
};
